// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2JTlQ","productName":"Table_productName__1DV0_"};